import React, { FC, SVGProps } from 'react'
import styled, { DefaultTheme } from 'styled-components'

import { box } from '@Globals/Style/mixins'

interface SVGIconProps {
  className?: string
  color?: keyof DefaultTheme['colors']
  icon: FC<SVGProps<SVGSVGElement>>
  size?: string
  strokeColor?: keyof DefaultTheme['colors'] | 'none'
  strokeWidth?: string
}

type StyledProps = {
  color: keyof DefaultTheme['colors']
  size: string
  strokeColor: keyof DefaultTheme['colors'] | 'none'
  strokeWidth: string
}

export const StyledSVGIcon = styled.div<StyledProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: ${({ size }) => size};
  width: ${({ size }) => size};

  > svg {
    ${box({ width: '100%' })};
    fill: ${({ color, theme }) => (theme.colors[color])};
    stroke: ${({ strokeColor, theme }) => (theme.colors[strokeColor])};
    stroke-width: ${({ strokeWidth }) => (strokeWidth)};
  }
`

export const SVGIcon: FC<SVGIconProps> = (
  {
    className,
    color = 'greyDark',
    icon: Icon,
    size = '20px',
    strokeColor = 'none',
    strokeWidth = '1px',
  }: SVGIconProps,
) => (
  <StyledSVGIcon aria-hidden className={className} color={color} size={size} strokeColor={strokeColor} strokeWidth={strokeWidth}>
    <Icon />
  </StyledSVGIcon>
)
